import { Controller } from "@hotwired/stimulus"
import { marked } from "marked"
import DOMPurify from "dompurify"

// Connects to data-controller="markdown-preview"
export default class extends Controller {
  static targets = ["input", "output"]

  connect() {
    // Configure marked options to match server-side Redcarpet settings
    marked.setOptions({
      breaks: true,      // hard_wrap equivalent
      gfm: true,         // GitHub Flavored Markdown (enables autolink, fenced code blocks, strikethrough)
      tables: true,      // Ensure tables are rendered like on the server
      pedantic: false    // Approximate no_intra_emphasis behavior
    })

    // Initial render
    this.update()
  }

  update() {
    const markdown = this.inputTarget.value

    if (markdown.trim() === "") {
      this.outputTarget.innerHTML = '<p class="text-gray-400 italic">Preview will appear here...</p>'
    } else {
      const html = marked.parse(markdown)
      this.outputTarget.innerHTML = DOMPurify.sanitize(html)
    }
  }
}
